// Mutations

export default {
  SetUserInfo(state, payload) {
    state.user_info = payload
  },
  SetUserType(state, payload) {
    state.user_type = payload
  },
  SetNewPassword(state){
    state.modal_window = !state.modal_window
  }
}
